// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Dpst","row":"Node_row__clMr0","label":"Node_label__75Heq","footer":"Node_footer__2GDYz"};